"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixpanelPlugin = void 0;
var vue_1 = require("vue");
var mixpanel = require("mixpanel-browser");
exports.MixpanelPlugin = {
    install: function (vue, options) {
        vue_1.default.prototype.$mixpanel = mixpanel;
        if (options === null || options === void 0 ? void 0 : options.token) {
            vue_1.default.prototype.$mixpanel.init(options.token);
            var config = (options === null || options === void 0 ? void 0 : options.config) || {};
            vue_1.default.prototype.$mixpanel.set_config(config);
        }
    }
};
exports.default = exports.MixpanelPlugin;
//# sourceMappingURL=index.js.map